export default __webpack_public_path__ + "static/media/oh.4f702be8.mp3";